module.exports = __webpack_public_path__ + "img/2022-2.0c1aa634.jpg";